export class DataForPeersModal {
    peers         = [];
    peerSelected  = [];
}
